<template>
  <nav class="layout-header">
    <div class="navbar">
      <a href="/root" class="navbar-brand">
        <img src="@/assets/images/logo.png?" width="35" />
        &nbsp;
        <span v-if="platformTitle && platformTitle != 'undefined'">
          {{ platformTitle }}
        </span>
        <span v-else>虚拟云教具实训平台</span>
      </a>
      <ul class="pc">
        <li
          class="nav-item"
          v-for="(link, i) in links"
          :key="link.label"
          @click="handlePath(link.path, i)"
        >
          <div class="nav-link">
            <i :class="'icon' + ' ' + link.icon"></i>
            {{ getLabel(link) }}
          </div>
        </li>
      </ul>
      <div class="mobile">
        <i class="navbar-toggler-icon" @click="showLink = !showLink"></i>
      </div>
    </div>
    <ul class="mobile-nav" :style="!showLink ? 'height: 0;' : 'height: 240px;'">
      <li
        class="nav-item"
        v-for="(link, i) in links"
        :key="link.label"
        @click="handlePath(link.path, i)"
      >
        <div class="nav-link">
          <i :class="'icon' + ' ' + link.icon"></i>
          {{ getLabel(link) }}
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import _ from 'lodash'
export default {
  name: 'layout-header',
  components: {},
  props: [],
  data() {
    return {
      links: [
        { path: '/resources', label: '云标本', icon: 'i-m-svs' },
        { path: '/experiments', label: '云实验', icon: 'i-experiment' },
        { path: '/courses', label: '智慧课本', icon: 'i-courses' },
        {
          path: 'https://t.vrbook.vip',
          label: '老师端',
          icon: 'i-subj-phisycs',
        },
        {
          path: 'https://s.vrbook.vip',
          label: '学生端',
          icon: 'iconfont icon-yewutubiao_xueshengchaxun',
        },
        { path: '/login', label: '登录', icon: 'i-user' },
      ],
      showLink: false,
    }
  },
  watch: {},
  computed: {
    ...mapState({
      login: (state) => state.login,
      platformTitle: (state) => state.platformTitle,
    }),
  },
  created() {
    let token = Cookies.get('token')
    this.$store.commit('SET_LOGIN', token ? true : false)
    const vipInfo = Cookies.get('vipInfo')
    if (vipInfo) {
      this.$store.commit('SET_STATE', {
        key: 'platformTitle',
        value: JSON.parse(vipInfo)?.nickname || '虚拟云教具实训平台',
      })
    }
  },
  methods: {
    getLabel({ path, label }) {
      switch (path) {
        case '/login':
          return this.login ? '退出登录' : '登录'

        default:
          return label
      }
    },
    handlePath(path, i) {
      this.showLink = false
      if (this.$route.path === path) return
      switch (i) {
        case 5:
          if (!this.login) {
            this.$router.push(path)
          } else {
            this.logout()
          }

          break
        case 3:
        case 4:
          window.location.href = path
          break

        default:
          this.$router.push(path)
          break
      }
    },
    logout() {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        window.localStorage.removeItem('token')
        Cookies.remove('token')
        location.reload()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-header {
  width: 100%;
  background: #343a40;
  ul {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    li {
      list-style-type: none;
      display: list-item;
      text-align: -webkit-match-parent;
      cursor: pointer;
    }
  }
  .nav-link {
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s linear;
    padding: 0.4rem 2rem;

    &.active,
    &:hover {
      background: #454d55;
      color: #fff;
    }
  }
  .navbar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .navbar-brand {
      display: flex;
      align-items: center;
      padding: 0;
      margin-right: 1rem;
      margin-left: 1rem;
      line-height: inherit;
      white-space: nowrap;
      color: #fff;
    }
    .mobile {
      display: none;
      padding: 0.25rem 0.75rem;
      font-size: 1.25rem;
      line-height: 1;
      background-color: transparent;
      .navbar-toggler-icon {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        content: '';
        background: no-repeat 50%;
        background-size: 100% 100%;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
      }
    }
  }
  .mobile-nav {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    list-style: none;
    transition: all 0.5s;
    overflow: hidden;
    color: white;
    li {
      width: 100%;
      height: 40px;
    }
  }
}

@media (max-width: 800px) {
  .layout-header {
    font-size: 1rem;
    .navbar {
      .pc {
        display: none;
      }
      .mobile {
        display: block;
      }
    }
  }
}

@media only screen and (min-width: 600px) and (max-width: 1024px) {
  .layout-header {
    .nav-link {
      font-size: 1.5vw;
    }
  }
}
</style>
